import { render, staticRenderFns } from "./ArticleCard.vue?vue&type=template&id=92324bf4"
import script from "./ArticleCard.vue?vue&type=script&lang=js"
export * from "./ArticleCard.vue?vue&type=script&lang=js"
import style0 from "./ArticleCard.vue?vue&type=style&index=0&id=92324bf4&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports